fx.ns("shared.popups", class NewFileLostCoverPopup extends shared.popups.BasePersonPopup{
    
    constructor(book, action)
    {
        super(book, fx.get("assets").personAdvice);
        this.contentWidth = 500;
        this.contentHeight = 250;

        this.book = book;
        this.action = action;
    }

    get photo()
    {
        return this.data;
    }


 
    create()
    {
        super.create();

        let title = fx.text("Votre fichier a été importé !");
        let message = fx.text("Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun texte important ne soit trop proche des bords. Il risquerai d'être coupé à la fabrication.");
            
        this.addChild(new fx.components.Text({text:title, className:"title center"}));
        this.addChild(new fx.components.Text({text:message, className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
    }


});